import { Input, Radio } from 'antd5';
import styled from 'styled-components';

const getDepthMargin = (depth: number) => `${depth * 0.75}rem`;

export const ModeGroup = styled(Radio.Group)`
  margin-bottom: 0.75rem;
`;

export const EditorPanel = styled.div`
  font-family: monospace;
  font-size: 0.8rem;
  line-height: 1.2;
  max-height: 24rem;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.borderColor};
  padding: 0.5rem;
`;

export const RawTextArea = styled(Input.TextArea)``;

export const EditableValueContainer = styled.div<{ $depth: number; $active: boolean }>`
  margin-left: ${({ $depth }) => getDepthMargin($depth)};
  ${({ $active, theme }) => $active && `background: ${theme.selectedListItemBackground};`}
  padding: 0.125rem 0.25rem;
`;

export const EditableValueInline = styled.span<{ $depth: number; $active: boolean }>`
  margin-left: ${({ $depth }) => getDepthMargin($depth)};
  ${({ $active, theme }) => $active && `background: ${theme.selectedListItemBackground};`}
  padding: 0.125rem 0.25rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`;

export const EditableValueText = styled.span`
  min-width: 0;
`;

export const InlineEditAction = styled.span<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  flex: 0 0 auto;
`;

export const JsonCollection = styled.div<{ $depth: number; $active: boolean }>`
  margin-left: ${({ $depth }) => getDepthMargin($depth)};
  ${({ $active, theme }) => $active && `background: ${theme.selectedListItemBackground};`}
`;

export const JsonChildRow = styled.div`
  margin-left: 0.75rem;
`;

export const CollectionHeader = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`;

export const ValueActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.25rem;
`;

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.red};
  margin-top: 0.5rem;
`;

export const PopoverContent = styled.pre`
  margin: 0;
  font-family: monospace;
  font-size: 0.75rem;
  line-height: 1.15;
  white-space: pre;
  max-height: 22rem;
  min-width: 20rem;
  overflow: auto;
`;

export const JsonTrigger = styled.button`
  border: 0;
  padding: 0;
  background: ${({ theme }) => theme.primaryBackgroundColor};
  color: inherit;
  cursor: pointer;
  font: inherit;
  text-decoration: underline;
`;
